import { render, staticRenderFns } from "./play_en.vue?vue&type=template&id=30b3fd65&scoped=true&"
import script from "./play_en.vue?vue&type=script&lang=js&"
export * from "./play_en.vue?vue&type=script&lang=js&"
import style0 from "./play_en.vue?vue&type=style&index=0&id=30b3fd65&prod&lang=less&scoped=true&"
import style1 from "./play_en.vue?vue&type=style&index=1&id=30b3fd65&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b3fd65",
  null
  
)

export default component.exports